import * as types from './ActionsUser';

export default function navigationReducer(
    state = {
        connected: false,
        user: []
    }, action: any) {
    switch (action.type) {
        case types.USER_LOGIN_SUCCESS:
            state.connected = true;
            break;
        case types.USER_LOGIN_ERROR:
            state.connected = false;
            break;
        case types.USER_LOGOUT:
            state.connected = false;
            break;
    }

    return { ...state };
}



// WEBPACK FOOTER //
// ./src/app/stores/reducers/user/UserReducer.ts